const network = process.env.REACT_APP_CLIENT_NETWORK || "local";
export default network;
